export const convertToConsoleHexString = (data: string[] | string) => {
  if (typeof data === 'string') data = data.split('');
  return data.map((val) => `0x${val.charCodeAt(0).toString(16)}`);
};
